export const props = {
  action: { default: "" },
  clipStudioPaintDownloadLink: { default: "" },
  contractNumber: { default: "" },
  currentContractData: {
    default: () => ({
      deviceType: "",
      gradeType: "",
      termType: "",
      currencyCode: "",
      currentPlanCode: ""
    })
  },
  deviceChoice: {
    default: () => {}
  },
  defaultData: {
    default: () => ({
      deviceType: "",
      gradeType: "",
      termType: "",
      currencyCode: "",
      currentPlanCode: ""
    })
  },
  deviceUseRangeUrl: { default: "" },
  gradeChoice: {
    default: () => {}
  },
  gradeDifferenceUrl: { default: "" },
  galaxyHelpUrl: { default: "" },
  lang: {
    default: () => {}
  },
  planName: {
    default: () => {}
  },
  prevUrl: { default: "" },
  prevPath: { default: "" },
  priceMap: {
    default: () => {}
  },
  planListUrl: { default: "" },
  resultPlansMap: {
    default: () => {}
  },
  termChoice: {
    default: () => {}
  },
  urlHelpDifferenceAmount: { default: "" },
  urlHelpChangeDevice: { default: "" },
  urlHelpContinuedPatronage: { default: "" },
  urlHelpGalaxy: { default: "" },
  urlHelpChangeFreeTrial: { default: "" },
  urlDifferenceInGrade: { default: "" },
  vandleCardUrl: { default: "" },
  urlGradeChange: { default: "" },
  isPaypalContract: { default: false },
  isIce: { default: false },
  paymentInformationEditUrl: { default: "" },
  contractDetailLink: { default: "" },
  paymentType: { default: "" }
};
